<mat-nav-list>
  <mat-list-item class="section-text-container">
    {{ name }}
  </mat-list-item>
  <ng-content select="rezolve-navbar-item"></ng-content>
</mat-nav-list>
